// extracted by mini-css-extract-plugin
export default {"title":"title_title__BdHj7","largeTitle":"title_largeTitle__CggKP"};